const n8nChatbotDictPT = {
  // Interface texts
  chatTitle: "Chat Extraconomy",
  chatTitleDev: "Chat Extraconomy (Modo Dev)",
  statusOnline: "Online",
  statusOffline: "Offline",
  statusChecking: "Verificando...",
  statusDevMode: "Modo Dev",
  placeholder: "Digite sua mensagem...",
  tooltip: "Fale conosco!",

  // Welcome message
  welcomeMessage: "Olá! Sou o assistente virtual da Extraconomy. Como posso ajudá-lo hoje?",

  // Loading states
  typing: "Digitando...",

  // Error messages
  errorGeneric: "Desculpe, estou com dificuldades técnicas no momento. Por favor, entre em contato através do email: suporte@extraconomy.com",
  errorWithDetails: "Desculpe, estou com dificuldades técnicas no momento. Por favor, entre em contato através do email: suporte@extraconomy.com\n\nErro: {error}",

  // Fallback responses
  fallbackResponse: "Obrigado pela sua mensagem! Estou aqui para ajudar com informações sobre a Extraconomy. Você pode perguntar sobre cadastro, planos, funcionalidades ou qualquer outra dúvida!"
};

export default n8nChatbotDictPT;
